import { AnimatePresence, motion } from "framer-motion";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//STYLES
import { ContainerPatri } from "./styled";

//APP
import { transition_default } from "../../../../../../utils";
import { PatrimonioSaida } from "../../meta/obter_dados";
import { Empty, Modal, Tooltip } from "antd";
import { useEffect, useRef, useState } from "react";
import { Item__Atividades, ItemPropriedades } from "../../../../../../services/atividades/GET";
import { ModalPatrimonio } from "./modal";

//PROPS
interface Props {
    dados_patrimonios: PatrimonioSaida[];
    data_atividades: Item__Atividades[];
    data_propriedades: ItemPropriedades[]
}

export const Patrimonios: React.FC<Props> = ({ dados_patrimonios, data_atividades, data_propriedades }) => {

    //REFs
    const refPopupTipo = useRef(null);
    const refPopupTipoAtv = useRef(null);

    //#region STATES
    const [open_tipo_atv, setOpen_tipo_atv] = useState<boolean>(false);
    const [tipo_atv_selecionada, setTipo_atv_selecionada] = useState<string>('executadas');
    const [open_tipo, setOpen_tipo] = useState<boolean>(false);
    const [tipo_selecionada, setTipo_selecionada] = useState<string>('Odometro');
    const [cod_patrimonio_selecionado, setCod_patrimonio_selecionado] = useState<number>(null);
    const [open_modal, setOpen_modal] = useState<boolean>(false);
    const [title_modal, setTitle_modal] = useState<string>('');

    const handleClickOutside: any = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (refPopupTipo.current && !refPopupTipo.current.contains(event.target)) {
            setOpen_tipo(false);
        }
        if (refPopupTipoAtv.current && !refPopupTipoAtv.current.contains(event.target)) {
            setOpen_tipo_atv(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true)
        return () => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    })

    const list_filter = (dados_patrimonios ?? []).filter(item => item.tipo === tipo_selecionada && item.filtro === (tipo_atv_selecionada.toLowerCase().includes('plan') ? 'Planejadas' : 'Executadas'));

    return (
        <ContainerPatri
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...transition_default, delay: 0.6 }}
        >
            <p className="ContainerPatri__title">Patrimonios</p>

            <motion.button className="ContainerPatri__unidade" style={{ right: 120 }} whileTap={{ scale: 0.98 }} onClick={() => setOpen_tipo_atv(!open_tipo_atv)}>
                {tipo_atv_selecionada}
                <FontAwesomeIcon icon={faAngleDown} />
            </motion.button>

            <motion.button className="ContainerPatri__unidade" whileTap={{ scale: 0.98 }} onClick={() => setOpen_tipo(!open_tipo)}>
                {tipo_selecionada?.replace('horimetro', 'horímetro')?.replace('Odometro', 'Odômetro')}
                <FontAwesomeIcon icon={faAngleDown} />
            </motion.button>

            <AnimatePresence>
                {open_tipo_atv && (
                    <motion.div
                        ref={refPopupTipoAtv}
                        className="ContainerPatri__opt_unidade"
                        style={{ right: 60 }}
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0, y: -20 }}
                    >
                        <motion.button className="ContainerPatri__opt_unidade__item" whileTap={{ scale: 0.98 }} onClick={() => { setTipo_atv_selecionada('executados'); setOpen_tipo_atv(false) }}>
                            Executadas
                        </motion.button>
                        <motion.button className="ContainerPatri__opt_unidade__item" whileTap={{ scale: 0.98 }} onClick={() => { setTipo_atv_selecionada('planejados'); setOpen_tipo_atv(false) }}>
                            Planejadas
                        </motion.button>
                    </motion.div>
                )}
            </AnimatePresence>

            <AnimatePresence>
                {open_tipo && (
                    <motion.div
                        ref={refPopupTipo}
                        className="ContainerPatri__opt_unidade"
                        style={{ right: 0 }}
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0, y: -20 }}
                    >
                        <motion.button className="ContainerPatri__opt_unidade__item" whileTap={{ scale: 0.98 }} onClick={() => { setTipo_selecionada('Odometro'); setOpen_tipo(false) }}>
                            Odômetro
                        </motion.button>
                        <motion.button className="ContainerPatri__opt_unidade__item" whileTap={{ scale: 0.98 }} onClick={() => { setTipo_selecionada('Horimetro'); setOpen_tipo(false) }}>
                            Horímetro
                        </motion.button>
                    </motion.div>
                )}
            </AnimatePresence>

            <div className="ContainerPatri__list">
                {list_filter.map(({ nome_patrimonio, tipo, area_utilizada, calculo_percorrido, media_area, cod_patrimonio }, index) => {
                    let opacity_green_light = (0.3 + (0.1 * index));
                    return (
                        <motion.button className="ContainerPatri__list__item" whileTap={{ scale: 0.95 }} onClick={() => { setTitle_modal(nome_patrimonio); setCod_patrimonio_selecionado(cod_patrimonio); setOpen_modal(true) }}>
                            <div className="ContainerPatri__list__item__name">
                                {String(nome_patrimonio).toLowerCase()}
                            </div>
                            <div className="ContainerPatri__list__item__values">
                                <Tooltip title={tipo === 'Odometro' ? 'Odômetro percorrido' : 'Horímetro percorrido'}>
                                    <div className="ContainerPatri__list__item__values__item">
                                        <span>{tipo}</span>
                                        <p>{calculo_percorrido} {tipo === 'Odometro' ? 'km' : 'h'}</p>
                                    </div>
                                </Tooltip>
                                <Tooltip title={'Área percorrida'}>
                                    <div className="ContainerPatri__list__item__values__item">
                                        <span>Área</span>
                                        <p style={{ textTransform: 'none' }}>{area_utilizada?.toFixed(2)} ha</p>
                                    </div>
                                </Tooltip>
                                <Tooltip title={tipo === 'Odometro' ? "Média da área percorrida por km percorrido" : "Média da área percorrida por h percorrido"}>
                                    <div
                                        className="ContainerPatri__list__item__values__item"
                                        data-hightlight={true}
                                        style={{
                                            background: `rgb(152, 202, 129, ${opacity_green_light})`,
                                            color: '#227242'
                                        }}
                                    >
                                        <span>Média</span>
                                        <p style={{ textTransform: 'none' }}>{tipo === 'Odometro' ? `${media_area?.toFixed(2)} ha/km` : `${media_area?.toFixed(2)} ha/h`}</p>
                                    </div>
                                </Tooltip>
                            </div>
                        </motion.button>
                    )
                })}

                {list_filter.length === 0 && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"Nenhum registro encontrado!"} />
                )}

                {(dados_patrimonios.length > 0 && ((dados_patrimonios ?? [])).length === 0) && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"Nenhum registro encontrado!"} />
                )}

            </div>

            <Modal
                open={open_modal}
                onCancel={() => setOpen_modal(false)}
                footer={false}
                title={title_modal ?? 'Detalhes do patrimônio'}
                width={1185}
                destroyOnClose
            >
                <ModalPatrimonio
                    cod_patrimonio_selecionado={cod_patrimonio_selecionado}
                    data_atividades={data_atividades}
                    data_propriedades={data_propriedades}
                />
            </Modal>

        </ContainerPatri>
    )
}